import { render, staticRenderFns } from "./ListTabelaValores.vue?vue&type=template&id=06ea293e"
import script from "./ListTabelaValores.vue?vue&type=script&lang=js"
export * from "./ListTabelaValores.vue?vue&type=script&lang=js"
import style0 from "./ListTabelaValores.vue?vue&type=style&index=0&id=06ea293e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports